<template>
  <div class="flex items-center w-40 flex-row flex-nowrap justify-start px-2 box-border">
    <ProjectIcon
      class="min-w-[16px] flex"
      :project-icon="projectIconSrc"
      :project-color="projectIconColor"
      :type="projectIconType || iconEnum"
    />
    <span
      class="card-project-label overflow-hidden text-ellipsis whitespace-nowrap text-xs ml-2 text-text-default"
    >
      {{ project.title || '' }}
    </span>
  </div>
</template>

<script>
import customIconsMixin from '@/mixins/customIconsMixin';
import ProjectIcon from '@/components/elements/common/ProjectIcon';

export default {
  components: {
    ProjectIcon,
  },
  mixins: [customIconsMixin],

  props: {
    projectId: {
      type: String,
      default: '',
      required: true,
    },
  },

  computed: {
    project() {
      return this.$store.getters.getTeamProjectById(this.projectId) || {};
    },
    projectIconSrc() {
      return this.project.icon?.src || '';
    },
    projectIconColor() {
      return this.project.icon?.color || '';
    },
    projectIconType() {
      return this.project.icon?.type || '';
    },
  },
};
</script>
